"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _CommunicationSettings = _interopRequireDefault(require("./CommunicationSettings"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _CommunicationSettings.default;
exports.default = _default;